import { INVOICE_STATUS } from "modules/invoice/types/invoice.interface";

export enum ReductionType {
  PERCENTAGE = "percentage",
  AMOUNT = "amount",
}

export class CommandeLineItem {
  _id?: string;
  articleId: string;
  description: string;
  checked: boolean;
  vatAmount: number;
  quantity: number;
  unitPriceHT?: number;
  reductionAmount: number;
  reductionType: ReductionType;
  totalTTC: number;
  totalHT: number;
  priceHT: number;
}

export interface DocumentNumber {
  number: string;
  prefix: string;
  suffix: string;
}

export interface CommandeSummary {
  totalHT: number;
  totalRemise: number;
  totalHTFinal: number;
  totalVAT: number;
  totalTTC: number;
  vatPercentage: number;
}

export class Commande {
  _id: string;
  documentNumber: DocumentNumber;
  createdAt: Date;
  updatedAt: Date;
  archived: boolean;
  lineItems: CommandeLineItem[];
  summary?: CommandeSummary;
  notes: string;
  savedDocuments: string[];
  linkedInvoices: {
    _id: string;
    number: DocumentNumber;
    status: INVOICE_STATUS;
  }[];
  clientId: string;
  client: {
    _id: string;
    name: string;
  };
  ebpId: string;
  workspaceId: string;
  devisId: string;
  totalTTC: number;
  totalHT: number;
  dueDate?: Date;
  status?: INVOICE_STATUS;
}

export class CreateCommandePayload {
  _id?: string;
  lineItems?: CommandeLineItem[];
  notes?: string;
  savedDocuments?: (string | File)[];
  linkedInvoices?: {
    _id: string;
    number: DocumentNumber;
    status: INVOICE_STATUS;
  }[];
  clientId: string;
  totalTTC: number;
  totalHT: number;
  dueDate?: Date | null;
  devisId?: string;
}

export interface DeleteDocumentPayload {
  commandeId: string;
  url: string;
}
